// Single source of truth for VCare contact numbers (footer + call-only service pages).
// `display` follows a consistent "+94 XX XXX XXXX" pattern; `tel` is the dialable form.
export const CONTACT_NUMBERS = [
  { display: '+94 77 393 9112', tel: '+94773939112' },
  { display: '+94 76 799 7796', tel: '+94767997796' },
  { display: '+94 77 700 4068', tel: '+94777004068' },
  { display: '+94 11 317 6545', tel: '+94113176545' },
];
